export default __webpack_public_path__ + "static/media/writer.90837901.svg";